'use client'

import { DataList } from '@morpho-org/ui-v6/client'
import { Skeleton } from '@morpho-org/ui-v6/server'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

import { HeaderOracles } from '../OraclesMarket'

const PRICE_CONSTRUCTION_SKELETON_HEIGHT = 'h-[270px] md:h-[254px]'

const InfoCardLoading = () => {
  return (
    <DataList.Line>
      <Skeleton className="h-md w-[100%] rounded-[20px]" />
    </DataList.Line>
  )
}

const OracleAttributesLoading = () => {
  return (
    <div className="gap-2xs flex w-full flex-col">
      <HeaderOracles />
      <DataList.Root>
        <DataList.Column>
          {Array.from({ length: 5 }, (_, index) => (
            <InfoCardLoading key={index} />
          ))}
        </DataList.Column>
        <DataList.Column>
          {Array.from({ length: 4 }, (_, index) => (
            <InfoCardLoading key={index} />
          ))}
        </DataList.Column>
      </DataList.Root>
    </div>
  )
}

const OraclePriceConstructionLoading = () => {
  return (
    <div className="gap-sm flex w-full flex-col">
      <SubSectionTitle>Oracle price construction</SubSectionTitle>
      <div className="gap-lg flex flex-col">
        <Skeleton className={`${PRICE_CONSTRUCTION_SKELETON_HEIGHT} w-full rounded-[20px]`} />
      </div>
    </div>
  )
}

/**
 * Models the oracle attributes with five left rows and four right rows, plus the decoded
 * price-construction table.
 */
const OraclesMarketLoading = () => {
  return (
    <div className="gap-lg sm:gap-xl flex w-full flex-col">
      <OracleAttributesLoading />
      <OraclePriceConstructionLoading />
    </div>
  )
}

export default OraclesMarketLoading
